export const LanguagesInMelbourne = [
  {
    heading: "Chinese Translation",
    detail:
      "Mandarin is spoken by at least 184,977 residents in Melbourne. Our Chinese translation is tailored to the needs of everyone in Melbourne. For both private and business applications, we guarantee that your chinese translator is well equipped to handle translations for any industry to and from Chinese.",
    link: "/mandarin-chinese-translation",
  },
  {
    heading: "French Translation",
    detail:
      "Tomedes' French translators help eliminate language barriers among the 21% of Melbourne's French population. A major language in the whole world, French translation can be a stepping stone in solving your business or individual needs. Whether it's French to English or vice versa, or any other language pair you choose, we can provide quality translation services for you. ",
    link: "/french-translation.php",
  },
  {
    heading: "Japanese Translation",
    detail:
      "At Tomedes, Japanese translators are just a call away to translate from English to Japanese. We are well-qualified to translate your documents, localize your app, or any other services you may need for the Japanese language. A Japanese translator from Tomedes will be a native-language translator, so no need to worry.",
    link: "/japanese-translation.php",
  },
  {
    heading: "Arabic Translation",
    detail:
      "There are 420 million people who speak Arabic in the world, while around 321,000 speak it in Australia. At Tomedes, Arabic translations can connect this global business language to the needs of Melbourne consumers, and beyond. Whether you need Arabic interpreters or Arabic translators skilled in Arabic script translation, just reach out.",
    link: "/arabic-translation.php",
  },
  {
    heading: "Polish Translation",
    detail:
      "About 16,439 Polish-speaking people reside in Melbourne's Polish communities. Access this population with translation services fit for the needs of these communities through a Polish translator. Tomedes' global network of translators can connect you to the right Polish translator that also specialises in the industry you're in. Contact us today.",
    link: "/polish-translation.php",
  },
  {
    heading: "Spanish Translation",
    detail:
      "There's an estimated 463 million people who speak Spanish worldwide, while in Australia there's a 123,000 Spanish population. If you're thinking about travelling to or localizing in Melbourne, translation services could benefit your individual and business needs with a Spanish translator. Why not reach out now.",
    link: "/spanish-translation.php",
  },
];
